import Button, { ButtonProps } from '@material-ui/core/Button';

export default (props: ButtonProps) => {
  const { color = 'primary' } = props;
  return <Button variant="outlined" {...props} color={color} />;
};
